import React, {Component} from "react";
import $ from "jquery";
import datepicker from "js-datepicker";
import {ROUTE_RISK_ASSESSMENT} from '../Constants';
import {Badge} from "reactstrap";

export default class RouteRiskAssessment  extends Component{

    constructor(props) {

        super(props);

        this.state = ROUTE_RISK_ASSESSMENT;
    }

    componentDidMount(){
        const {position} = this.props;
        this.initDatePicker(position);
        let data = this.props.data;
        let keys = Object.keys(data);

        if(data){
            for (let key in keys){
                this.setState({[keys[key]]: data[keys[key]]});
            }
        }
    }

    onChange = (event) => {
        this.onValueChange(event.target.name, event.target.value)
    };

    onValueChange= (name, value) => {
        this.setState({
            [name]: value
        });
        this.props.update(this.props.type,  this.props.position, name, value);
    };

    initDatePicker(position){

        let that = this;

        if($(document).find(`.datepicker_${position}`).length > 0){
            datepicker(document.querySelector(`.datepicker_${position}`), {
                position: 'c',
                startDate: new Date(),
                startDay: 1,
                dateSelected: new Date(),
                minDate: new Date(2016, 5, 1),
                maxDate: new Date(2099, 0, 1),
                noWeekends: false,
                customMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                customDays: ['S', 'M', 'T', 'W', 'Th', 'F', 'S'],
                overlayPlaceholder: 'Enter a 4-digit year',
                overlayButton: 'Select!',
                disableMobile: false,

                formatter: (input, date, instance) => {
                    that.onValueChange($(input).attr('name'), date.toDateString());
                    input.value = date.toDateString()
                },
            });
        }


    };


    render(){

        const {
            rates,
            removeActivity,
            type,
            position
        } = this.props;


        const {
            assessment_date,
            route_name,
            optimum_traffic_patterns_times,
            highly_hazardous_intersections_along_routes,
            any_overhead_hazards,
            construction_along_routes,
            severity,
            likelihood,
            makeup_and_tonnage_of_each_shipment,
            access_to_delivery_points_along_routes,
        } = this.state;

        return(
            <div className="template-holder" style={{backgroundColor: "#ccc",padding: "10px",borderRadius: "4px",marginBottom: "15px",position: "relative"}}>
                {
                    position !== 0?
                        <Badge
                            onClick={() => removeActivity(type, position)}
                            color="danger" style={{position: "absolute", right: "15px", cursor: "pointer", zIndex:1000}}>X</Badge>: null
                }
                <div className="form-group" style={{position: 'relative'}}>
                    <label htmlFor="assessment_date" className="control-label required">
                        Assessment data</label>
                    <input
                        onChange={this.onChange}
                        className={`form-control datepicker_${position}`}
                        autoComplete="off"
                        required="required"
                        name="assessment_date"
                        type="text"
                        id={`assessment_date_${position}`}/>
                </div>
                <div className="form-group">
                    <label
                        htmlFor="route_name"
                        className="control-label required">
                        Route name
                    </label>
                    <textarea rows={1} onChange={this.onChange} className="form-control required" name="route_name" id="route_name" value={route_name}/>
                </div>
                <div className="form-group">
                    <label
                        htmlFor="optimum_traffic_patterns_times"
                        className="control-label required">
                        Optimum traffic patterns and times
                    </label>
                    <textarea onChange={this.onChange}
                              rows={3}
                              className="form-control required"
                              name="optimum_traffic_patterns_times"
                              id="optimum_traffic_patterns_times" value={optimum_traffic_patterns_times}/>
                </div>

                <div className="form-group" style={{width: '100%'}}>
                    <label
                        htmlFor="highly_hazardous_intersections_along_routes"
                        className="control-label required">
                        Highly hazardous intersections along routes
                    </label>
                    <textarea onChange={this.onChange}
                              rows={3}
                              className="form-control required"
                              name="highly_hazardous_intersections_along_routes"
                              id="highly_hazardous_intersections_along_routes" value={highly_hazardous_intersections_along_routes}/>
                </div>

                <div className="form-group" style={{width: '100%'}}>
                    <label
                        htmlFor="any_overhead_hazards"
                        className="control-label required">
                        Any overhead hazards
                    </label>
                    <textarea onChange={this.onChange}
                              rows={3}
                              placeholder="e.g. low bridges, power cables, illegal connection along the route"
                              className="form-control required"
                              name="any_overhead_hazards"
                              id="any_overhead_hazards" value={any_overhead_hazards}/>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="construction_along_routes"
                        className="control-label required">
                        Construction along routes
                    </label>
                    <textarea onChange={this.onChange}
                              rows={3}
                              className="form-control required"
                              name="construction_along_routes"
                              id="construction_along_routes" value={construction_along_routes}/>
                </div>

                <div className="form-group" style={{width: '100%'}}>
                    <label
                        htmlFor="access_to_delivery_points_along_routes"
                        className="control-label required">
                        Access to delivery points along routes
                    </label>
                    <textarea onChange={this.onChange}
                              rows={3}
                              className="form-control required"
                              name="access_to_delivery_points_along_routes"
                              id="access_to_delivery_points_along_routes" value={access_to_delivery_points_along_routes}/>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="makeup_and_tonnage_of_each_shipment"
                        className="control-label required">
                        Make-up and tonnage of each shipment
                    </label>
                    <textarea onChange={this.onChange}
                              rows={3}
                              className="form-control required"
                              name="makeup_and_tonnage_of_each_shipment"
                              id="makeup_and_tonnage_of_each_shipment" value={makeup_and_tonnage_of_each_shipment}/>
                </div>

                <h6>Risk Rating: </h6>

                <div style={{display: 'flex', flexDirection: 'columns'}}>
                    <div className="form-group" style={{width: '100%'}}>
                        <label
                            htmlFor="severity"
                            className="control-label required">
                            Severity
                        </label>
                        <select
                            value={severity}
                            onChange={this.onChange}
                            className="selectpicker form-control"
                            required="required"
                            id="severity"
                            name="severity">
                            <option value="">Select an option</option>
                            {
                                Object.keys(rates).map(key => <option key={key} value={key}>{rates[key]}</option>)
                            }
                        </select>

                    </div>
                    <div className="form-group" style={{width: '100%'}}>
                        <label
                            htmlFor="likelihood"
                            className="control-label required">
                            Likelihood
                        </label>
                        <select
                            value={likelihood}
                            onChange={this.onChange}
                            className="selectpicker form-control"
                            required="required"
                            id="likelihood"
                            name="likelihood">
                            <option value="">Select an option</option>
                            {
                                Object.keys(rates).map(key => <option key={key} value={key}>{rates[key]}</option>)
                            }
                        </select>

                    </div>
                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/screens/risks/templates/RouteRiskAssessment.js